var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-container",style:(_vm.conditionContainerStyle)},[(_vm._child)?_c('inner-children-renderer',{attrs:{"children":_vm._child}}):_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }